import { ContentService, LandingPageItem } from '@agingplan';
import { Component } from '@angular/core';

@Component({
  selector: 'app-book-us',
  templateUrl: './book-us.component.html',
  styleUrls: ['./book-us.component.scss'],
})
export class BookUsComponent {
  /**
   * The booking page
   */
  public page$ = this.contentService.booking$;

  /**
   * Is the user viewing an embed?
   */
  public viewingEmbed = false;

  constructor(private contentService: ContentService) {}

  public go(item: LandingPageItem) {
    if (item.action === 'embed' && item.embed) {
      this.viewingEmbed = true;
      const parent = document.getElementById('embed');

      if (parent) {
        parent.innerHTML = item.embed;
        const docScript = parent.getElementsByTagName('script')[0];
        const script = document.createElement('script');

        if (docScript) {
          script.setAttribute('src', docScript.getAttribute('src') || '');
          parent.appendChild(script);
        }
      }
    }

    return true;
  }

  public back(): void {
    window.history.back();
  }
}
